(function ($, debounce) {
  'use strict';

  $(document).ready(() => {
    $('.field--name-field-feedback .field__items .slick_slider').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      direction: "vertiacl",
      arrows: true,
      appendArrows: $(".arrows"),
      prevArrow: "<button class=\"slick-prev\"><i class=\"fa-regular fa-chevron-left fs-18 t-yellow\"></i></button>",
      nextArrow: "<button class=\"slick-next\"><i class=\"fa-regular fa-chevron-right fs-18 t-yellow\"></i></button>",
      adaptiveHeight: true,
    });

    $(".toggle_full_version").on("click", debounce((element) => {
      $(element.currentTarget).parent().find("span.open").slideToggle();
      $(element.currentTarget).parent().find("span.closed").slideToggle();
      $(element.currentTarget).parent().find(".full_version").slideToggle();
      $(element.currentTarget).parent().parent().find(".short_version").slideToggle();
      setTimeout(() => {
        $('.field--name-field-feedback .field__items .slick_slider').slick("refresh");
      }, 400)
    }, 50));

    $(window).on("resize", debounce(() => {
      $('.field--name-field-feedback .field__items .slick_slider').slick("refresh");
    }, 50))

  });

})(jQuery, Drupal.debounce);
